import SHEEP_BOMB_SPLAT_IMAGE_URL from './sheepSplat.webp';
export { SHEEP_BOMB_SPLAT_IMAGE_URL };
export const SHEEP_BOMB_SPLAT_SPRITESHEET_DATA = {
    frames: {
        'sheepSplat0001.png': {
            frame: { x: 1, y: 1, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 1, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0002.png': {
            frame: { x: 255, y: 1, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0003.png': {
            frame: { x: 509, y: 1, w: 246, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 10, w: 246, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0004.png': {
            frame: { x: 762, y: 1, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 1, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0005.png': {
            frame: { x: 1, y: 191, w: 248, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 3, y: 10, w: 248, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0006.png': {
            frame: { x: 256, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0007.png': {
            frame: { x: 510, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0008.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0009.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0010.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0011.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0012.png': {
            frame: { x: 819, y: 381, w: 247, h: 189 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 4, w: 247, h: 189 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0013.png': {
            frame: { x: 813, y: 635, w: 247, h: 193 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 0, w: 247, h: 193 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0014.png': {
            frame: { x: 776, y: 889, w: 247, h: 190 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 3, w: 247, h: 190 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0015.png': {
            frame: { x: 509, y: 951, w: 247, h: 187 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 6, w: 247, h: 187 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0016.png': {
            frame: { x: 255, y: 951, w: 247, h: 185 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 8, w: 247, h: 185 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0017.png': {
            frame: { x: 1, y: 951, w: 247, h: 184 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 9, w: 247, h: 184 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0018.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0019.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0020.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0021.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0022.png': {
            frame: { x: 1, y: 381, w: 259, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 259, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0023.png': {
            frame: { x: 267, y: 381, w: 267, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 267, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0024.png': {
            frame: { x: 541, y: 381, w: 271, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 271, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0025.png': {
            frame: { x: 1, y: 571, w: 268, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 268, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0026.png': {
            frame: { x: 276, y: 571, w: 264, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 264, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0027.png': {
            frame: { x: 547, y: 571, w: 259, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 259, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0028.png': {
            frame: { x: 1, y: 761, w: 254, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 254, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0029.png': {
            frame: { x: 262, y: 761, w: 251, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 251, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0030.png': {
            frame: { x: 520, y: 761, w: 249, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 249, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0031.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0032.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0033.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0034.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        },
        'sheepSplat0035.png': {
            frame: { x: 764, y: 191, w: 247, h: 183 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 10, w: 247, h: 183 },
            sourceSize: { w: 273, h: 193 },
            anchor: { x: 0.490842, y: 0.927461 }
        }
    },
    animations: {
        animation: [
            'sheepSplat0001.png',
            'sheepSplat0002.png',
            'sheepSplat0003.png',
            'sheepSplat0004.png',
            'sheepSplat0005.png',
            'sheepSplat0006.png',
            'sheepSplat0007.png',
            'sheepSplat0008.png',
            'sheepSplat0009.png',
            'sheepSplat0010.png',
            'sheepSplat0011.png',
            'sheepSplat0012.png',
            'sheepSplat0013.png',
            'sheepSplat0014.png',
            'sheepSplat0015.png',
            'sheepSplat0016.png',
            'sheepSplat0017.png',
            'sheepSplat0018.png',
            'sheepSplat0019.png',
            'sheepSplat0020.png',
            'sheepSplat0021.png',
            'sheepSplat0022.png',
            'sheepSplat0023.png',
            'sheepSplat0024.png',
            'sheepSplat0025.png',
            'sheepSplat0026.png',
            'sheepSplat0027.png',
            'sheepSplat0028.png',
            'sheepSplat0029.png',
            'sheepSplat0030.png',
            'sheepSplat0031.png',
            'sheepSplat0032.png',
            'sheepSplat0033.png',
            'sheepSplat0034.png',
            'sheepSplat0035.png'
        ]
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.1',
        image: SHEEP_BOMB_SPLAT_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 1012, h: 1139 },
        scale: '0.35',
        smartupdate: '$TexturePacker:SmartUpdate:320ba6c18aa61b009eb150a4e1849e85:b69b307ef33af7f051b8e01d8a1aaed1:3c057d5826cba4bc94186fff2f3aa840$'
    }
};
